// 导航栏配置
<template>
    <div class="navigation-bar-box">
        <div class="view-box">
            <div class="screen-switch">
                <div class="screen-item" :class="{'is-active': currentScreen === item.id}" v-for="item in screenSwitchList" :key="item.id" @click="screenSwitch(item)">
                    <i class="icon" :class="{'portrait-icon': item.id === 1, 'landscape-icon': item.id === 2}"></i>{{item.name}}
                </div>
            </div>
            <div class="view-wrap">
                <div class="view" :class="{'landscape-background': currentScreen === 2}">
                    <div v-if="currentScreen === 1" class="portrait-view">
                        <div class="top">
                            <div class="top-item">
                                <div class="left-item">
                                    <div class="item" v-for="(item, index) in portraitTopBtnList" :key="'left'+item.tag">
                                        <div v-show="index <= 1" class="icon" :class="[{[item.icon]: item.checked}]">
                                            {{ item.tag === 3 && item.checked ? '结束': '' }}
                                        </div>
                                    </div>
                                </div>
                                <div class="title">这里是你的房间主题<span class="title-icon"></span></div>
                                <div class="right-item">
                                    <div class="item" v-for="(item, index) in portraitTopBtnList" :key="'right'+item.tag">
                                        <div v-show="index === 2" class="icon" :class="[{[item.icon]: item.checked}]">
                                            {{ item.tag === 3 && item.checked ? '结束': '' }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="bottom">
                            <div class="bottom-item" v-show="item.checked" v-for="item in portraitBottomBtnList" :key="item.tag">
                                <div class="icon" :class="[item.icon]"></div>
                                <div class="item-name" v-show="item.checked">{{ item.viewName }}</div>
                            </div>
                        </div>
                    </div>
                    <div v-else class="landscape-view">
                        <div class="top">
                            <div class="top-item">
                                <div class="left-item">
                                    <div class="item" v-for="(item, index) in landscapeTopBtnList" :key="'left'+item.tag">
                                        <div v-show="index <= 1" class="icon" :class="[{[item.icon]: item.checked}]">
                                            {{ item.tag === 3 && item.checked ? '结束房间': '' }}
                                        </div>
                                    </div>
                                </div>
                                <div class="title">这里是你的房间主题<span class="title-icon"></span></div>
                                <div class="right-item">
                                    <div class="item" v-for="(item, index) in landscapeTopBtnList" :key="'right'+item.tag">
                                        <div v-show="index === 2" class="icon" :class="[{[item.icon]: item.checked}]">
                                            {{ item.tag === 3 && item.checked ? '结束房间': '' }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="bottom">
                            <div class="content" v-for="(item, index) in landscapeBottomBtnList" :key="item.tag">
                                <div class="line" v-show="index === landscapeBottomBtnList.length-2"></div>
                                <div class="bottom-item" v-show="item.checked">
                                    <div class="icon" :class="[item.icon]"></div>
                                    <div class="item-name" v-show="item.checked">{{ item.viewName }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="control-box">
            <div class="nav-switch">
                <div class="nav-item" :class="{'is-active': currentNav === item.id}" v-for="item in navSwitchList" :key="item.id" @click="navSwitch(item)">
                    {{item.name}}
                </div>
            </div>
            <div class="top-nav" v-if="currentNav === 1">
                <div class="title bold">顶部栏配置</div>
                <template v-if="currentScreen === 1">
                    <draggable v-model="portraitTopBtnList" @start="onStart" @end="onEnd('top')" chosenClass="chosen" animation="500">
                        <div class="top-nav-item" v-for="item in portraitTopBtnList" :key="item.tag">
                            <div class="item-name">
                                <div class="square">
                                    <div class="square-item" v-for="index in 4" :key="index"></div>
                                </div>
                                {{item.controlName}}
                            </div>
                            <div class="checkbox">
                                <el-checkbox v-model="item.checked" @change="checkboxChange($event,'top')"></el-checkbox>
                            </div>
                        </div>
                    </draggable>
                </template>
                <template v-else>
                    <draggable v-model="landscapeTopBtnList" @start="onStart" @end="onEnd('top')" chosenClass="chosen" animation="500">
                        <div class="top-nav-item" v-for="item in landscapeTopBtnList" :key="item.tag">
                            <div class="item-name">
                                <div class="square">
                                    <div class="square-item" v-for="index in 4" :key="index"></div>
                                </div>
                                {{item.controlName}}
                            </div>
                            <div class="checkbox">
                                <el-checkbox v-model="item.checked" @change="checkboxChange($event,'top')"></el-checkbox>
                            </div>
                        </div>
                    </draggable>
                </template>
            </div>
            <div class="bottom-nav" v-else>
                <div class="title bold">底部栏配置</div>
                <template v-if="currentScreen === 1">
                    <draggable v-model="portraitBottomBtnList" @start="onStart" @end="onEnd('bottom')" chosenClass="chosen" animation="500">
                        <div class="bottom-nav-item" v-for="item in portraitBottomBtnList" :key="item.tag">
                            <div class="item-name">
                                <div class="square">
                                    <div class="square-item" v-for="index in 4" :key="index"></div>
                                </div>
                                {{item.controlName}}
                            </div>
                            <div class="checkbox">
                                <el-checkbox v-model="item.checked" @change="checkboxChange($event,'bottom')"></el-checkbox>
                            </div>
                        </div>
                    </draggable>
                </template>
                <template v-else>
                    <draggable v-model="landscapeBottomBtnList" @start="onStart" @end="onEnd('bottom')" chosenClass="chosen" animation="500">
                        <div class="bottom-nav-item" v-for="item in landscapeBottomBtnList" :key="item.tag">
                            <div class="item-name">
                                <div class="square">
                                    <div class="square-item" v-for="index in 4" :key="index"></div>
                                </div>
                                {{item.controlName}}
                            </div>
                            <div class="checkbox">
                                <el-checkbox v-model="item.checked" @change="checkboxChange($event,'bottom')"></el-checkbox>
                            </div>
                        </div>
                    </draggable>
                </template>
            </div>
        </div>
    </div>
</template>
<script>
import draggable from 'vuedraggable'
export default {
  props: {
    config: {
      type: Object,
      default: Object
    }
  },
  data () {
    return {
      drag: false,
      // 取默认值因为父组件传的config可能会缺少按钮 页面控制面板展示的按钮要是全部按钮
      portraitTopBtnList: [].concat(this.config.portrait.topView.left_item, this.config.portrait.topView.right_item),
      portraitBottomBtnList: this.config.portrait.bottomView.items,
      landscapeTopBtnList: [].concat(this.config.landscape.topView.left_item, this.config.landscape.topView.right_item),
      landscapeBottomBtnList: this.config.landscape.bottomView.items,
      screenSwitchList: [
        {
          id: 1,
          name: '竖屏'
        },
        {
          id: 2,
          name: '横屏'
        }
      ],
      currentScreen: 1,
      navSwitchList: [
        {
          id: 1,
          name: '顶部导航'
        },
        {
          id: 2,
          name: '底部导航'
        }
      ],
      currentNav: 1
    }
  },
  created () {
    this.getConfigData()
  },
  watch: {
    config (val) {
      // 获取父组件调用接口请求后的配置文件
      this.config = val
      this.currentScreen = 1
      this.getConfigData()
    }
  },
  methods: {
    navSwitch (data) {
      this.currentNav = data.id
    },
    screenSwitch (data) {
      this.currentScreen = data.id
      switch (data.id) {
        case 1:
          this.currentNav = 1
          break
        case 2:
          this.currentNav = 1
          break
      }
    },
    // 获取对应的配置参数
    getConfigData () {
      const portraitObj = this.transConfigData(this.portraitTopBtnList, this.portraitBottomBtnList, 'portrait')
      this.portraitTopBtnList = portraitObj.top
      this.portraitBottomBtnList = portraitObj.bottom
      const landscapeObj = this.transConfigData(this.landscapeTopBtnList, this.landscapeBottomBtnList, 'landscape')
      this.landscapeTopBtnList = landscapeObj.top
      this.landscapeBottomBtnList = landscapeObj.bottom
    },
    transConfigData (top, bottom, item) {
      // 根据最新配置文件更新view
      const diffBottm = this.getDifference(bottom, this.config[item].bottomView.items, 'tag')
      bottom = JSON.parse(JSON.stringify(this.config[item].bottomView.items))
      bottom.forEach(defaultItem => {
        defaultItem.checked = true
        switch (defaultItem.tag) {
          case 20:
            defaultItem.viewName = '讨论'
            defaultItem.controlName = '讨论功能'
            break
          case 21:
            defaultItem.viewName = '成员'
            defaultItem.controlName = '成员列表功能'
            break
          case 22:
            defaultItem.viewName = '共享'
            defaultItem.controlName = '共享功能'
            break
          case 23:
            defaultItem.viewName = '摄像头'
            defaultItem.controlName = '摄像头功能'
            break
          case 24:
            defaultItem.viewName = '麦克风'
            defaultItem.controlName = '麦克风功能'
            break
          case 25:
            defaultItem.viewName = '上台'
            defaultItem.controlName = '上台功能'
            break
        }
      })
      if (diffBottm.length) {
        diffBottm.forEach(diffItem => {
          diffItem.checked = false
          bottom.push(diffItem)
        })
      }
      const concatArray = [].concat(this.config[item].topView.left_item, this.config[item].topView.right_item)
      // 顺序问题
      switch (concatArray.length) {
        case 3:
          top = concatArray
          break
        case 2: case 1:
          const uncheckedArray = this.getDifference(top, concatArray, 'tag')
          uncheckedArray.forEach((item) => { item.checked = false })
          if (this.config[item].topView.right_item.length) {
            const array = this.config[item].topView.left_item.concat(uncheckedArray).concat(this.config[item].topView.right_item)
            top = JSON.parse(JSON.stringify(array))
          } else {
            top = JSON.parse(JSON.stringify(concatArray.concat(uncheckedArray)))
          }
          break
        case 0:
          top.forEach((item) => {
            item.checked = false
          })
          break
      }
      top.forEach((defaultItem, index) => {
        switch (defaultItem.tag) {
          case 1:
            defaultItem.controlName = '更多按钮'
            break
          case 2:
            defaultItem.controlName = '窗口最小化按钮'
            break
          case 3:
            defaultItem.controlName = '离开/结束按钮'
            break
        }
        if (concatArray.some(item => item.tag === defaultItem.tag)) {
          this.$set(defaultItem, 'checked', true)
        }
      })
      return { top, bottom }
    },
    // 开始拖拽事件
    onStart () {
      this.drag = true
    },
    // 拖拽结束事件
    onEnd (type) {
      this.drag = false
      this.updateConfig(type)
    },
    checkboxChange (e, type) {
      this.updateConfig(type)
    },
    // 将改动赋值给配置文件
    updateConfig (type) {
      // 顶部工具栏分为左右两部分 index里的changeConfig每次都会去重组顶部工具栏 所以不管任何改动都要重新给顶部工具栏赋值
      this.config.portrait.topView.left_item = this.portraitTopBtnList
      this.config.portrait.topView.right_item = []
      this.config.landscape.topView.left_item = this.landscapeTopBtnList
      this.config.landscape.topView.right_item = []
      this.config.portrait.bottomView.items = this.portraitBottomBtnList
      this.config.landscape.bottomView.items = this.landscapeBottomBtnList
    },
    // 求两个数组对象的差集
    getDifference (arr1, arr2, param) {
      return Object.values(arr1.concat(arr2).reduce((acc, cur) => {
        if (acc[cur[param]] && acc[cur[param]][param] === cur[param]) {
          delete acc[cur[param]]
        } else {
          acc[cur[param]] = cur
        }
        return acc
      }, {}))
    }
  },
  components: {
    draggable
  }
}
</script>
<style lang="less" scoped>
.navigation-bar-box {
    display: flex;
    border-radius: 4px;
    width: 100%;
    min-height: 100%;
    .view-box {
        overflow: scroll;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-left: 160px;
        .screen-switch {
            flex-shrink: 0;
            margin: 24px 0;
            display: flex;
            width: 160px;
            height: 32px;
            background-color: #FFFFFF;
            box-shadow: 0px 2px 16px 0px rgba(218, 222, 232, 0.06);
            border-radius: 4px;
            .screen-item {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 50%;
                height: 100%;
                cursor: pointer;
                font-size: 12px;
                color: #636c78;
                .icon{
                    display: flex;
                    align-items: center;
                    width: 20px;
                    height: 20px;
                    &.portrait-icon{
                        margin-left: -3px;
                        margin-right: 1px;
                        background-image: url('../assets/img/portrait-icon.png');
                        background-size: cover;
                    }
                    &.landscape-icon{
                        margin-left: -3px;
                        margin-right: 5px;
                        background-image: url('../assets/img/landscape-icon.png');
                        background-size: cover;
                    }
                }
                &.is-active{
                    background-color: rgba(37, 99, 235, 0.1);
                    box-shadow: 0px 2px 16px 0px rgba(218, 222, 232, 0.06);
                    border-radius: 4px;
                    border: 1px solid #0062F4;
                    color: #2563EB;
                    .icon{
                        &.portrait-icon{
                            background-image: url('../assets/img/portrait-icon-active.png');
                        }
                        &.landscape-icon{
                            background-image: url('../assets/img/landscape-icon-active.png');
                        }
                    }
                }
            }
        }
        .view-wrap {
            display: flex;
            align-items: center;
            flex-grow: 1;
            .view {
                background-color: #171717;
                background-image: url('../assets/img/portrait-screen.png');
                background-size: cover;
                &.landscape-background {
                    background-image: url('../assets/img/landscape-screen.png');
                }
                .portrait-view, .landscape-view {
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    width: 375px;
                    height: 667px;
                    .top {
                        position: relative;
                        display: flex;
                        align-items: center;
                        padding: 0 14px;
                        height: 48px;
                        background-color: rgba(0, 0, 0, 0.8);
                        .top-item {
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            width: 100%;
                            .title {
                                position: absolute;
                                left: 50%;
                                transform: translate(-50%);
                                font-size: 16px;
                                color: #fff;
                                .title-icon {
                                    display: inline-block;
                                    margin-left: 3px;
                                    width: 12px;
                                    height: 12px;
                                    background-image: url('../assets/img/open-icon.png');
                                    background-size: cover;
                                }
                            }
                            .left-item {
                                display: flex;
                                align-items: center;
                                .item{
                                    &:nth-child(1){
                                        margin-right: 18px;
                                    }
                                }
                            }
                            .icon {
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                min-width: 24px;
                                height: 24px;
                                font-size: 15px;
                                color: #FF5248;
                                background-size: cover;
                                &.roomkit_more {
                                    background-image: url('../assets/img/more-icon.png');
                                }
                                &.roomkit_nav_minimize {
                                    background-image: url('../assets/img/minimize-icon.png');
                                }
                            }
                        }
                    }
                    .bottom {
                        display: flex;
                        justify-content: center;
                        padding: 0 16px;
                        height: 55px;
                        background-color: rgba(0, 0, 0, 0.8);
                        .bottom-item {
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            align-items: center;
                            margin-top: 6px;
                            margin-right: 31px;
                            width: 44px;
                            height: 44px;
                            .icon {
                                margin-bottom: 4px;
                                width: 25px;
                                height: 25px;
                                background-size: cover;
                                &.roomkit_discussion {
                                    background-image: url('../assets/img/discussion-icon.png');
                                }
                                &.roomkit_member {
                                    background-image: url('../assets/img/member-icon.png');
                                }
                                &.roomkit_share {
                                    background-image: url('../assets/img/share-icon.png');
                                }
                                &.roomkit_close_camera {
                                    background-image: url('../assets/img/camera-icon.png');
                                }
                                &.roomkit_close_microphone {
                                    background-image: url('../assets/img/microphone-icon.png');
                                }
                                &.roomkit_toolbar_onstage_icon2 {
                                    background-image: url('../assets/img/on-stage-icon.png');
                                }
                            }
                            .item-name {
                                font-size: 18px;
                                color: #FFFFFF;
                                zoom: 0.5;
                            }
                            &:last-child {
                                margin-right: 0;
                            }
                        }

                    }
                }
                .landscape-view {
                    width: 667px;
                    height: 375px;
                    .top{
                        .top-item{
                            .title {
                                font-size: 17px;
                            }
                        }
                    }
                    .bottom {
                        .content {
                            display: flex;
                            align-items: center;
                            .line {
                                margin-right: 8px;
                                width: 1px;
                                height: 28px;
                                background-color: #666666;
                            }
                            .bottom-item {
                                margin-right: 8px;
                                align-self: flex-start;
                            }
                        }

                    }
                }
            }
        }
    }
    .control-box {
        z-index: 6;
        position: fixed;
        right: 0;
        overflow: scroll;
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 272px;
        height: calc(100% - 64px);
        background-color: #FFFFFF;
        color: #636c78;
        .square {
            display: flex;
            flex-wrap: wrap;
            margin-right: 10px;
            width: 6px;
            height: 6px;
            .square-item {
                width: 2px;
                height: 2px;
                background-color: #9DA3AC;
                &:nth-child(2n+1){
                    margin-right: 2px;
                }
                &:nth-child(-n+2){
                    margin-bottom: 2px;
                }
            }
        }
        .nav-switch {
            display: flex;
            margin-top: 24px;
            margin-bottom: 18px;
            width: 224px;
            height: 34px;
            background-color: #FFFFFF;
            border-radius: 4px;
            border: 1px solid #E0E0E0;
            .nav-item {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 50%;
                height: 100%;
                cursor: pointer;
                font-size: 13px;
                &.is-active:nth-child(1) {
                    transform: translate(-1px, -1px);
                }
                &.is-active:nth-child(2) {
                    transform: translate(1px, -1px);
                }
                &.is-active{
                    background-color: rgba(37, 99, 235, 0.1);
                    border-radius: 4px;
                    border: 1px solid #0062F4;
                    color: #2563EB;
                    box-sizing: content-box;
                }
            }
        }
        .top-nav {
            display: flex;
            flex-direction: column;
            align-items: center;
            .title, .top-nav-item {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 6px;
                padding-left: 10px;
                width: 244px;
                height: 36px;
                font-size: 12px;
                color: #33383e;
                .item-name {
                    display: flex;
                    align-items: center;
                }
                .checkbox {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 38px;
                    height: 36px;
                    cursor: pointer;
                }
                &.bold {
                    font-size: 13px;
                    font-weight: bold;
                }
            }
            .top-nav-item:hover{
                background-color: #F6F7F9;
                cursor: grab;
                border-radius: 4px;
            }
        }
        .bottom-nav {
            display: flex;
            flex-direction: column;
            .title, .bottom-nav-item {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 6px;
                padding-left: 10px;
                width: 244px;
                height: 36px;
                font-size: 12px;
                color: #33383e;
                .item-name {
                    display: flex;
                    align-items: center;
                }
                .checkbox {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 38px;
                    height: 36px;
                    cursor: pointer;
                }
                &.bold {
                    font-size: 13px;
                    font-weight: bold;
                }
            }
            .bottom-nav-item:hover{
                cursor: grab;
                background-color: #F6F7F9;
                border-radius: 4px;
            }
        }
    }
}
</style>
<style scoped>
.el-checkbox >>> .el-checkbox__input {
    height: 14px;
}
.el-checkbox >>> .el-checkbox__input > .el-checkbox__inner {
    border-color: #d9d9d9;
}
.el-checkbox >>> .el-checkbox__input > .el-checkbox__inner:hover {
    border-color: #0062f4;
}
.el-checkbox >>> .el-checkbox__input.is-checked > .el-checkbox__inner {
    background-color: #0062f4;
    border-color: #0062f4;
}
</style>



// WEBPACK FOOTER //
// src/views/navigation-bar.vue